import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import Color from 'color';
import { defaultTheme } from '../../constants/appConfig';
import Spinner from '../../assets/svg/button-spinner.svg';

const PrimaryButton = styled.button`
  &.design-primary {
    color: ${props => (props.theme ? props.theme.primaryTextColor : defaultTheme.primaryTextColor)};
    background: ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};

    &:focus {
      background: ${props => Color(props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor).darken(0.2).hex()};
    }

    &:hover {
      background: ${props => Color(props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor).darken(0.1).hex()};
    }

    &:active {
      background: ${props => Color(props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor).darken(0.2).hex()};
    }

    &.disabled {
      color: ${props => (props.theme ? props.theme.primaryTextColor : defaultTheme.primaryTextColor)};
      background: ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
    }
  }
  &.design-neutral {
    &:focus {
      box-shadow: 0 0 0 3px ${props => Color(props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor).fade(0.5).string()};
    }
  }
`;

export default class Button extends React.PureComponent {
  static propTypes = {
    label: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    design: PropTypes.oneOf(['primary', 'neutral']),
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    type: PropTypes.string,
    tabIndex: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    label: null,
    children: null,
    design: 'primary',
    disabled: false,
    loading: false,
    className: '',
    type: 'button',
    tabIndex: '',
    href: '',
    onClick: () => {},
  };

  button = React.createRef();

  onClick = () => {
    if (!this.props.disabled && !this.props.loading) {
      this.props.onClick();
    }
  };

  render() {
    const {
      design, disabled, loading, href, type, className, tabIndex, label, children,
    } = this.props;
    const cls = classnames('ui-button', `design-${design}`, className, {
      disabled,
      loading,
    });

    return (
      <PrimaryButton
        as={href ? 'a' : 'button'}
        ref={this.button}
        className={cls}
        href={href || undefined}
        type={href ? undefined : type}
        disabled={disabled || loading}
        tabIndex={tabIndex}
        onClick={this.onClick}
      >
        <span className="ui-button-content">
          <CSSTransition
            classNames="ui-button-spinner"
            timeout={300}
            in={loading}
            mountOnEnter
            unmountOnExit
          >
            <span className="ui-button-spinner">
              <Spinner className="ui-button-spinner-svg" />
            </span>
          </CSSTransition>
          <span className="ui-button-text">{label || children}</span>
        </span>
      </PrimaryButton>
    );
  }
}
